import { Listbox } from '@headlessui/react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';
import clsx from 'clsx';

const CustomListBox = ({
  label,
  options = [],
  selectedValue,
  onChange,
  displayKey = 'name',
  valueKey = 'id',
  placeholder = 'Select Option',
  name = '',
  openUpward = false,
}) => {
  return (
    <div className="relative font-poppins text-[15px] mt-[5px] mb-[20px]">
      <Listbox
        value={selectedValue}
        onChange={(value) => {
          onChange({ target: { name, value } }); // mimic native event
        }}
      >
        <div className="relative">
          <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color text-gray-main">
            <span className="block truncate">
              {
                selectedValue
                  ? options.find((opt) => opt[valueKey] === selectedValue)?.[displayKey]
                  : placeholder
              }
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
              <FaChevronDown className="h-3 w-3 text-gray-400" />
            </span>
          </Listbox.Button>

          <Listbox.Options
            className={clsx(
              'absolute z-10 max-h-60 w-full overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
              openUpward ? 'bottom-full mb-1' : 'top-full mt-1'
            )}
          >
            {options.map((item, index) => (
              <Listbox.Option key={item[valueKey]} value={item[valueKey]} disabled={item.disabled}>
                {({ active }) => (
                  <div
                    className={clsx(
                      'relative select-none py-2 pl-2 pr-8 flex justify-between items-center',
                      {
                        'cursor-not-allowed text-gray-400': item.disabled,
                        'cursor-pointer border-b border-[#28325A26]': index !== options.length - 1 && !item.disabled,
                        'text-deep-blue border-deep-blue': active && !item.disabled,
                        'text-gray-900': !active && !item.disabled,
                      }
                    )}
                  >
                    <span>{item[displayKey]}</span>
                    {!item.disabled && (selectedValue === item[valueKey] || active) && (
                      <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                        <FaCheck className="text-white text-[10px]" />
                      </span>
                    )}
                  </div>
                )}
              </Listbox.Option>

            ))}
          </Listbox.Options>
        </div>
      </Listbox>
    </div>
  );
};

export default CustomListBox;
